export enum BankAccountInformationType {
	International = "international",
	Local = "local"
}
